import validate from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.12.0_db0@0.2.3_ioredis@5.4.2_supports-_36967126bb4b787b983a3333236be67a/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/middleware/auth.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {
  "tat-admin-only": () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/middleware/tatAdminOnly.ts"),
  "tat-courier-only": () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/middleware/tatCourierOnly.ts"),
  "tat-picker-only": () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/middleware/tatPickerOnly.ts"),
  "tat-seller-only": () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/middleware/tatSellerOnly.ts"),
  "tat-super-admin-only": () => import("/Users/jorgemariogonzalez/Proyectos/Snapei/t2t-front/middleware/tatSuperAdminOnly.ts")
}